export function wrapNormalizerFn(fn) {
    return {
        normalize: fn
    };
}

//# sourceMappingURL=wrap-normalizer-fn.js.map